module.exports = __webpack_public_path__ + "static/media/action_limited.1ffdd308.png";